import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders, formAuthHeaders } from "../../utils/axios";

export const addNpaProperties = createAsyncThunk("property/addNpaProperties",async ({data}, { rejectWithValue }) => {
  try {
    const response = await Axios.post(`/api/admin/properties/add`,data,formAuthHeaders());
    return response.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const updateNpaProperties = createAsyncThunk("property/updateNpaProperties",async ({ id, data}, { rejectWithValue }) => {
  try {
    const response = await Axios.put(`/api/admin/properties/update/${id}`,data,formAuthHeaders());
    return response.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const deleteAllProperty = createAsyncThunk("properties/deleteProperty",async({id},{ rejectWithValue }) => {
    try{
     const response = await Axios.delete(`/api/admin/property/${id}`,authHeaders());
     return response.data; //success Case
    }catch(err){
      return rejectWithValue(err.message); // Error case
    }
})

export const npaAllProperties = createAsyncThunk(
  "properties/npaAllProperties",
  async (
    {
      status,
      page,
      limit,
      search,
      asset_category,
      property_type,     // string | string[]
      possession_type,   // string | string[]
      city_town,
      reserve_price,
      transaction_type,  // string | string[]
      is_public,
      land_types         // string
    },
    { rejectWithValue }
  ) => {
    try {
      const queryParams = new URLSearchParams();

      // Add parameters to query string
      if (status) queryParams.append("status", status);
      if (limit) queryParams.append("limit", limit);
      if (page) queryParams.append("page", page);
      if (search) queryParams.append("search", search);
      if (asset_category) queryParams.append("asset_category", asset_category);
      if (property_type) queryParams.append("property_type", property_type);
      if (possession_type) queryParams.append("possession", possession_type);
      if (city_town) queryParams.append("city_town", city_town);
      if (reserve_price) queryParams.append("reserve_price", reserve_price);
      if (transaction_type) queryParams.append("transaction_type", transaction_type);
      if (land_types) queryParams.append("land_types", land_types);
      
      // Only add is_public if it is true
      if (is_public === true) {
        queryParams.append("is_public", true);
      }

      // Make the API call with the dynamic query string
      const response = await Axios.get(`/api/admin/property?${queryParams.toString()}`, authHeaders());

      return response.data; // success case
    } catch (error) {
      return rejectWithValue(error.message); // error case
    }
  }
);

  export const fetchPropertyDetails = createAsyncThunk(
    "properties/fetchPropertyDetails",
    async ({id}, { rejectWithValue }) => {

      try {
        const response = await Axios.get(`/api/admin/property/${id}`, authHeaders());
        return response.data; // On success, return data
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message); // On failure, return error
      }
    }
  );

export const reqToGetFilterData = createAsyncThunk("properties/reqToGetFilterData",async ({ rejectWithValue }) => {
  try {
    const response = await Axios.get(`/api/bank/filters/metadata`,formAuthHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const importUserList = createAsyncThunk("properties/importUserList",async (data,{ rejectWithValue }) => {
  try {
    const response = await Axios.get(`/api/admin/users/bank-users`,data,authHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});


export const reqToImportNpaProperties = createAsyncThunk("properties/reqToImportNpaProperties",async ({data},{ rejectWithValue }) => {
  try {
    const response = await Axios.post(`/api/admin/properties/bulk-insert`,data,formAuthHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const propertyTypesDropdown = createAsyncThunk("properties/propertyTypesDropdown",async ({ rejectWithValue }) => {
  try {
    const response = await Axios.get(`/api/admin/properties/dropdowns`,authHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const changePublicStatus = createAsyncThunk(
  "properties/changePublicStatus",
  async ({ id, is_public }, { rejectWithValue }) => {
    try {
      const response = await Axios.put(
        `/api/admin/property/change-public-status/${id}`,
        { is_public },
        authHeaders()
      );
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const changeStatus = createAsyncThunk(
  "properties/changeStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await Axios.put(
        `/api/admin/property/status/${id}`,
        { status },
        authHeaders()
      );
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



const allPropertiesSlice = createSlice({
  name: "allProperties",
  initialState: {
    user: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
    property: [],
    propertyDetail:{},
    filter:{},
    addProperty:{},
    updateProperty:{},
    deleteNpaProperty:{},
    importData:[],
    importBankUsers:[],
    propertyDropdown:[],
  },
  reducers: {
    clearPropertyDetails(state) {
      state.propertyDetail = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
       // Add NPA Property
       .addCase(addNpaProperties.pending, (state, action) => {
        state.isLoading = true;
      })
       .addCase(addNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.addProperty = action.payload;
      })
      .addCase(addNpaProperties.rejected, (state, action) => {
        state.isLoading = false;
      })
      // Update NPA Property
      .addCase(updateNpaProperties.pending, (state, action) => {
        state.isLoading = true;
      })
        .addCase(updateNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updateProperty = action.payload;
      })
      .addCase(updateNpaProperties.rejected, (state, action) => {
        state.isLoading = false;
      })
       // NPA Property List
       .addCase(npaAllProperties.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(npaAllProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.property = action.payload;
      })
      .addCase(npaAllProperties.rejected, (state, action) => {
        state.isLoading = false;
      })
      // NPA Property Details
      // .addCase(propertyDetails.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.propertyDetail = action.payload;
      // })
      // Delete NPA Property

      .addCase(fetchPropertyDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPropertyDetails.fulfilled, (state, action) => {               
        state.isLoading = false;
        state.propertyDetail = action.payload.data;
      })
      .addCase(fetchPropertyDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload; // Handle error state
      })
      // .addCase(deleteProperty.pending, (state, action) => {
      //   state.isLoading = true;
      // })
      // .addCase(deleteProperty.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.deleteNpaProperty = action.payload;
      // })
      // .addCase(deleteProperty.rejected, (state, action) => {
      //   state.isLoading = false;
      // })
      // request to fetch filter data
      .addCase(reqToGetFilterData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.filter = action.payload;
      })
      // request to get list of Import Users
      .addCase(importUserList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.importBankUsers = action.payload;
      })
      // request to import Npa Properties
      .addCase(reqToImportNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.importData = action.payload;
      })
      // request to Types of property Dropdown
      .addCase(propertyTypesDropdown.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyDropdown = action.payload;
      })
  },
});
export const { clearPropertyDetails } = allPropertiesSlice.actions;
export default allPropertiesSlice.reducer;
